export enum FormSystemMetadataKeys {
  COMPONENTS = 'rxap/form-system/components',
  DATA_SOURCES = 'rxap/form-system/data-sources',
  COMPONENTS_PROPERTIES = 'rxap/form-system/components-properties',
  FORM_COMPONENT = 'rxap/window-form-system/form-component',
}
